export default __webpack_public_path__ + "static/media/logo.cdc0ac7c.png";